import { clsx } from 'clsx';
import { Modal } from '@/components/Modal';
import styles from './styles.module.css';
import type { ReactEventHandler } from 'react';
export interface VideoPlayerProps {
  hideVideo?: ReactEventHandler<HTMLDialogElement>;
  id: string;
  playInline?: boolean;
}
export const VideoPlayer: React.FC<VideoPlayerProps> = ({
  id,
  playInline,
  hideVideo
}) => {
  const iframe = <div className={clsx(styles.videoContainer, playInline ? undefined : styles.isModal)}>
      <iframe allow="autoplay" allowFullScreen frameBorder="0" sandbox="allow-scripts allow-popups allow-same-origin" src={`https://www.youtube.com/embed/${id}?rel=0&modestbranding=1&autohide=1&showinfo=0&autoplay=1`} title="Video" />
    </div>;
  if (playInline) {
    return iframe;
  }
  return <Modal onClose={hideVideo} data-sentry-element="Modal" data-sentry-component="VideoPlayer" data-sentry-source-file="VideoPlayer.tsx">{iframe}</Modal>;
};